import LogoWithWhiteFrameUrl from '@assets/logo-with-white-frame.png';
import { EventTypes } from '@racemap/sdk/schema/events';
import { DefaultLogoUrl } from '@racemap/utilities/consts/events';
import type { BrandPublicVersion } from '@racemap/utilities/types/brand';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Tag, Tooltip } from 'antd';
import type { Immutable } from 'immer';
import type { CurrentEvent } from '../store/events/events_reducers';

export function getSafemapUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return `${window.location.origin}/safemap/${
    event.slug != null && event.slug !== '' ? event.slug : event.id
  }`;
}

export function getRacemapLogoUrl() {
  return DefaultLogoUrl;
}

export function getEventTypeDocuLink(eventType: EventTypes) {
  switch (eventType) {
    case EventTypes.REGULAR:
    case EventTypes.CONTEST:
    case EventTypes.STAGE:
      return 'live-tracking/basic-features-of-racemap-tracking-map';
    case EventTypes.CONTEST_GROUP:
    case EventTypes.STAGE_GROUP:
      return 'live-tracking/multi-event-map';
    case EventTypes.SAFEMAP:
      return 'live-tracking/safemap';
    default:
      throw new Error(`Unknown event type: ${eventType}`);
  }
}

export function getAppLogoUrl(brand?: BrandPublicVersion | null) {
  return brand == null
    ? LogoWithWhiteFrameUrl
    : `${window.location.origin}/api/brands/${brand.id}/asset?asset=appIconTransparent`;
}

export function getLogoUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return event.images != null ? event.images.app : DefaultLogoUrl;
}

export function getDataFeedUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return `${window.location.origin}/api/data/v1/${event.id}`;
}

export function getParentEditorUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return `${window.location.origin}/admin/events/${event.parent}`;
}

export function getPreviewUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  const host =
    window.location.host === 'racemap.com' ? 'https://edge.racemap.com' : window.location.origin;
  return `${host}/api/events/${event.id}/preview`;
}

const EVENT_TYPE_BADGES: Record<EventTypes, { label: string; color: string; name: string }> = {
  [EventTypes.CONTEST]: { label: 'C', color: 'yellow', name: 'contest' },
  [EventTypes.CONTEST_GROUP]: { label: 'CG', color: 'volcano', name: 'contest group' },
  [EventTypes.REGULAR]: { label: 'R', color: 'green', name: 'regular' },
  [EventTypes.STAGE]: { label: 'S', color: 'blue', name: 'stage' },
  [EventTypes.STAGE_GROUP]: { label: 'SG', color: 'purple', name: 'stage group' },
  [EventTypes.SAFEMAP]: { label: 'SM', color: 'magenta', name: 'safemap' },
};

export function getEventTypeName(eventType: EventTypes): string {
  return EVENT_TYPE_BADGES[eventType]?.name ?? eventType;
}

// Bare tag without a tooltip — for callers that add their own tooltip/interaction.
export function getTypeTag(eventType: EventTypes) {
  const cfg = EVENT_TYPE_BADGES[eventType];
  return cfg == null ? null : <Tag color={cfg.color}>{cfg.label}</Tag>;
}

export function getTypeBadge(eventType: EventTypes) {
  const cfg = EVENT_TYPE_BADGES[eventType];
  return cfg == null ? null : (
    <Tooltip title={cfg.name}>
      <Tag color={cfg.color}>{cfg.label}</Tag>
    </Tooltip>
  );
}
